import {
  EmptyState,
  Loading,
  UpgradingIllustration,
} from '@angeplus/prever-component-lib';
import { useHasBenefit } from 'modules/contract/contract.store';
import { ContractEmptyState } from 'modules/contract/ContractEmptyState';
import { useWhatsappApi } from 'utils/useWhatsappApi';

export const TelevetBenefitEmptyStateDisplay = () => {
  const query = useHasBenefit();
  const { handleSendWhatsappMessage } = useWhatsappApi({
    phone: '+551132882526',
    text: 'Olá, gostaria de saber mais sobre o benefício de teleconsultas veterinárias.',
  });

  if (query?.isLoading) return <Loading />;

  if (!query?.data?.contract_active?.is_valid) return <ContractEmptyState />;

  return (
    <EmptyState
      illustration={<UpgradingIllustration />}
      description="Seu plano atual não possui o benefício de teleconsultas veterinárias. Entre em contato para saber mais sobre esse benefício."
      buttonLabelPrimary="Entrar em contato pelo WhatsApp"
      onClickButtonPrimary={handleSendWhatsappMessage}
    />
  );
};
